
const apiUrl = process.env.REACT_APP_API_BASE_URL;

export function getCacheInfo(token) {
    return fetch(encodeURI(apiUrl + "/api/admin/cache/pim/info" ),
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': 'Bearer ' + token
                    
                }
            })

        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`); 
            }
            return response.json();
        })
        .then(data => {
            return Array.isArray(data) ? data : [];
        })
        .catch(error => {
            console.error('getCacheInfo error: ', error);
            return [];
        });
}

export function clearCache(token) {
    return fetch(encodeURI(apiUrl + "/api/admin/cache/pim/clear"),
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token
                }
        })
        .then(response => {
            return  { ok: true, data: "response" };
        })
        .catch(error => {
            return { ok: false, data: "Unhandled error:" + error };
        });
}